// src/app/services/event-utils.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventUtilsService {

  areEventsEqual(e1: any, e2: any): boolean {
    const keysToCompare = [
      'title',
      'location',
      'customer',
      'start',
      'end',
      'resource',
      'description',
      'status',
      'ticketno',
      'category',
      'color',
      'cost',
      'type',
      'online',
      'onlineLink',
      'dolmetscher'
    ];

    return keysToCompare.every(key => {
      const val1 = e1[key];
      const val2 = e2[key];

      if (val1 instanceof Date && val2 instanceof Date) {
        return val1.getTime() === val2.getTime();
      }

      if (Array.isArray(val1) && Array.isArray(val2)) {
        return JSON.stringify(val1) === JSON.stringify(val2);
      }

      return val1 === val2;
    });
  }

}
